export default __webpack_public_path__ + "static/raised-fist-bd759c71dff6652fd02979cfdac4b764.jpg";